﻿const Scroll = {
    Behavior: {
        SMOOTH: 'smooth',
        FAST: 'fast',
        INSTANT: 'instant'
    },

    top: function (speed) {
        // Validate the speed variable
        if (!Object.values(this.Behavior).includes(speed)) {
            throw new Error(`Invalid speed value: ${speed}. Use 'smooth', 'fast', or 'instant'.`);
        }

        // Handle 'instant' scrolling separately
        if (speed === this.Behavior.INSTANT) {
            document.documentElement.style.scrollBehavior = "auto";
            document.documentElement.scrollTop = 0;
            document.body.scrollTop = 0;
            document.documentElement.style.scrollBehavior = "";
            return;
        }

        // Map 'fast' to 'auto' for instant-like behavior
        const behavior = speed === this.Behavior.FAST ? 'auto' : 'smooth';

        // Perform the scroll
        window.scrollTo({
            top: 0,
            behavior: behavior
        });
    },
    scrollToNextArticle: function (buffer = 200) {
        const articles = Array.from(document.querySelectorAll('article'))
            .filter(a => a.id !== 'parallax-divider');
        const currentScroll = window.scrollY + buffer;
        for (const article of articles) {
            const articleTop = article.getBoundingClientRect().top + window.scrollY;
            if (articleTop > currentScroll) {
                window.scrollTo({
                    top: articleTop,
                    behavior: 'smooth',
                });
                break;
            }
        }
    }
};

export default Scroll;